
import React, { Component } from "react";
import Head from "next/head";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import TagManager from 'react-gtm-module';
import SeoMeta from '/components/seoMeta';
import OurAudience from '/components/AdvertiseWithUs/OurAudience';
import IntroVideo from '/components/AdvertiseWithUs/IntroVideo';
import Connected from '/components/AdvertiseWithUs/Connected';
import Inventory from '/components/AdvertiseWithUs/Inventory';
import OurBrands from '/components/AdvertiseWithUs/OurBrands';
import Platforms from '/components/AdvertiseWithUs/Platforms';
import Services from '/components/AdvertiseWithUs/Services';
import Valuable from '/components/AdvertiseWithUs/Valuable';
import Divider from '@material-ui/core/Divider';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

class AdvertiseWithUs extends Component {
  render() {
    const { classes } = this.props; 
    return (
      <React.Fragment>
        <Head>
          <title>Advertise with us</title>
        <link rel="stylesheet" type="text/css" charSet="UTF-8" href="/static/css/advertiseWithUs.css" />
        <link href="https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap" rel="stylesheet" />                                    
        <link href="https://fonts.googleapis.com/css?family=Niconne" rel="stylesheet" />
        </Head>
        <SeoMeta 
            url={`${process.env.BACKEND_URL}/advertise-with-us`} 
            type="article"
            title='Advertise with us'
            description="Advertise with us"
            image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
            section='Advertise with us'
            keywords='Advertise with us'
          />        
        <NProgress />
        <IntroVideo />
        <div className="adws-wrapper" style={{fontFamily:"Roboto Condensed"}}>
        <OurAudience />
        <Connected />
        <Valuable />
        <Divider className="customHr" /> 
        <Inventory />
        <Divider className="customHr" /> 
        <Services />
        <OurBrands />
        <Platforms />
        </div>
    </React.Fragment>
    );
  }
    componentDidMount () {
     
    }

    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }
}
export default AdvertiseWithUs;